/* import __COLOCATED_TEMPLATE__ from './ticket-form-oh.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();